import script from "./Conteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./Conteudo.vue?vue&type=script&setup=true&lang=js"

import "./Conteudo.vue?vue&type=style&index=0&id=79b492aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b492aa"]])

export default __exports__